module.exports = __webpack_public_path__ + "img/set.0ff570ae.jpg";